<template>
  <MDBToast :model-value="showToast"
    @update:model-value="$emit('update:showToast', $event)"
    autohide
    :delay="delay ?? 3000"
    :position="position ?? 'top-right'"
    appendToBody
    stacking
    :width="width ?? '350px'"
    :toast="toast">
    <template #title>
      <slot name="title"></slot>
    </template>
    <slot></slot>
  </MDBToast>
</template>

<script>
export default {
  props: {
    showToast: {
      type: Boolean,
      required: true
    },
    toast: String,
    position: String,
    width: String,
    delay: Number
  },
  emits: ["update:showToast"],
  methods: {
  }
};
</script>